module.exports = "/assets/data/7db1d8514b4ac9fc1481458ab967435e-DN34.data.json";